"use client";
import { jsx as i, Fragment as k } from "react/jsx-runtime";
import * as c from "react";
import { composeEventHandlers as d } from "@radix-ui/primitive";
import { useComposedRefs as _ } from "@radix-ui/react-compose-refs";
import { createContextScope as L } from "@radix-ui/react-context";
import { useId as C } from "@radix-ui/react-id";
import { useControllableState as G } from "@radix-ui/react-use-controllable-state";
import { DismissableLayer as j } from "@radix-ui/react-dismissable-layer";
import { FocusScope as H } from "@radix-ui/react-focus-scope";
import "@radix-ui/react-portal";
import { Presence as y } from "@radix-ui/react-presence";
import { Primitive as p } from "@radix-ui/react-primitive";
import { useFocusGuards as K } from "@radix-ui/react-focus-guards";
import { RemoveScroll as U } from "react-remove-scroll";
import { hideOthers as V } from "aria-hidden";
import { Slot as Y } from "@radix-ui/react-slot";
const O = "Dialog", [E, go] = L(O), [Z, l] = E(O), h = (o) => {
  const { __scopeDialog: s, children: r, open: n, defaultOpen: t, onOpenChange: e, modal: u = !0 } = o, a = c.useRef(null), g = c.useRef(null), [D = !1, R] = G({
    prop: n,
    defaultProp: t,
    onChange: e
  });
  return /* @__PURE__ */ i(
    Z,
    {
      scope: s,
      triggerRef: a,
      contentRef: g,
      contentId: C(),
      titleId: C(),
      descriptionId: C(),
      open: D,
      onOpenChange: R,
      onOpenToggle: c.useCallback(() => R((S) => !S), [R]),
      modal: u,
      children: r
    }
  );
};
h.displayName = O;
const I = "DialogTrigger", q = c.forwardRef(
  (o, s) => {
    const { __scopeDialog: r, ...n } = o, t = l(I, r), e = _(s, t.triggerRef);
    return /* @__PURE__ */ i(
      p.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": t.open,
        "aria-controls": t.contentId,
        "data-state": P(t.open),
        ...n,
        ref: e,
        onClick: d(o.onClick, t.onOpenToggle)
      }
    );
  }
);
q.displayName = I;
const z = "DialogPortal", [mo, v] = E(z, {
  forceMount: void 0
}), m = "DialogOverlay", x = c.forwardRef(
  (o, s) => {
    const r = v(m, o.__scopeDialog), { forceMount: n = r.forceMount, ...t } = o, e = l(m, o.__scopeDialog);
    return e.modal ? /* @__PURE__ */ i(y, { present: n || e.open, children: /* @__PURE__ */ i(B, { ...t, ref: s }) }) : null;
  }
);
x.displayName = m;
const B = c.forwardRef(
  (o, s) => {
    const { __scopeDialog: r, ...n } = o, t = l(m, r);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ i(U, { as: Y, allowPinchZoom: !0, shards: [t.contentRef], children: /* @__PURE__ */ i(
        p.div,
        {
          "data-state": P(t.open),
          ...n,
          ref: s,
          style: { pointerEvents: "auto", ...n.style }
        }
      ) })
    );
  }
), f = "DialogContent", A = c.forwardRef(
  (o, s) => {
    const r = v(f, o.__scopeDialog), { forceMount: n = r.forceMount, ...t } = o, e = l(f, o.__scopeDialog);
    return /* @__PURE__ */ i(y, { present: n || e.open, children: e.modal ? /* @__PURE__ */ i(J, { ...t, ref: s }) : /* @__PURE__ */ i(Q, { ...t, ref: s }) });
  }
);
A.displayName = f;
const J = c.forwardRef(
  (o, s) => {
    const r = l(f, o.__scopeDialog), n = c.useRef(null), t = _(s, r.contentRef, n);
    return c.useEffect(() => {
      const e = n.current;
      if (e) return V(e);
    }, []), /* @__PURE__ */ i(
      N,
      {
        ...o,
        ref: t,
        trapFocus: r.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: d(o.onCloseAutoFocus, (e) => {
          e.preventDefault(), r.triggerRef.current?.focus();
        }),
        onPointerDownOutside: d(o.onPointerDownOutside, (e) => {
          const u = e.detail.originalEvent, a = u.button === 0 && u.ctrlKey === !0;
          (u.button === 2 || a) && e.preventDefault();
        }),
        onFocusOutside: d(
          o.onFocusOutside,
          (e) => e.preventDefault()
        )
      }
    );
  }
), Q = c.forwardRef(
  (o, s) => {
    const r = l(f, o.__scopeDialog), n = c.useRef(!1), t = c.useRef(!1);
    return /* @__PURE__ */ i(
      N,
      {
        ...o,
        ref: s,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (e) => {
          o.onCloseAutoFocus?.(e), e.defaultPrevented || (n.current || r.triggerRef.current?.focus(), e.preventDefault()), n.current = !1, t.current = !1;
        },
        onInteractOutside: (e) => {
          o.onInteractOutside?.(e), e.defaultPrevented || (n.current = !0, e.detail.originalEvent.type === "pointerdown" && (t.current = !0));
          const u = e.target;
          r.triggerRef.current?.contains(u) && e.preventDefault(), e.detail.originalEvent.type === "focusin" && t.current && e.preventDefault();
        }
      }
    );
  }
), N = c.forwardRef(
  (o, s) => {
    const { __scopeDialog: r, trapFocus: n, onOpenAutoFocus: t, onCloseAutoFocus: e, ...u } = o, a = l(f, r), g = c.useRef(null), D = _(s, g);
    return K(), /* @__PURE__ */ i(k, { children: /* @__PURE__ */ i(
      H,
      {
        asChild: !0,
        loop: !0,
        trapped: n,
        onMountAutoFocus: t,
        onUnmountAutoFocus: e,
        children: /* @__PURE__ */ i(
          j,
          {
            role: "dialog",
            id: a.contentId,
            "aria-describedby": a.descriptionId,
            "aria-labelledby": a.titleId,
            "data-state": P(a.open),
            ...u,
            ref: D,
            onDismiss: () => a.onOpenChange(!1)
          }
        )
      }
    ) });
  }
), T = "DialogTitle", F = c.forwardRef(
  (o, s) => {
    const { __scopeDialog: r, ...n } = o, t = l(T, r);
    return /* @__PURE__ */ i(p.h2, { id: t.titleId, ...n, ref: s });
  }
);
F.displayName = T;
const M = "DialogDescription", W = c.forwardRef(
  (o, s) => {
    const { __scopeDialog: r, ...n } = o, t = l(M, r);
    return /* @__PURE__ */ i(p.p, { id: t.descriptionId, ...n, ref: s });
  }
);
W.displayName = M;
const b = "DialogClose", w = c.forwardRef(
  (o, s) => {
    const { __scopeDialog: r, ...n } = o, t = l(b, r);
    return /* @__PURE__ */ i(
      p.button,
      {
        type: "button",
        ...n,
        ref: s,
        onClick: d(o.onClick, () => t.onOpenChange(!1))
      }
    );
  }
);
w.displayName = b;
function P(o) {
  return o ? "open" : "closed";
}
const Do = h, Ro = x, Co = A, _o = F, Oo = w;
export {
  Oo as Close,
  Co as Content,
  h as Dialog,
  w as DialogClose,
  A as DialogContent,
  W as DialogDescription,
  x as DialogOverlay,
  F as DialogTitle,
  q as DialogTrigger,
  Ro as Overlay,
  Do as Root,
  _o as Title,
  go as createDialogScope
};
